import { parse } from 'tldts';

const URL_SHORTENER_DOMAINS = new Set(['bit.ly', 't.co', 'goo.gl']);

/**
 * Returns the root domain (no subdomain, no path, no protocol).
 * Returns null if the URL is empty, invalid, or a known URL shortener.
 *
 * Examples:
 *   "www.lpl.com"            → "lpl.com"
 *   "www.faire.com/careers"  → "faire.com"
 *   "careers.makemytrip.com" → "makemytrip.com"
 *   "www.example.co.uk"      → "example.co.uk"
 *   "bit.ly/abc123"          → null
 */
export function formatWebsiteDomain(url: null | string | undefined): null | string {
  if (!url) return null;

  // Ensure the URL has a protocol so tldts can parse it correctly
  const normalized = /^https?:\/\//i.test(url) ? url : `https://${url}`;
  const { domain } = parse(normalized);

  if (!domain || URL_SHORTENER_DOMAINS.has(domain)) {
    return null;
  }

  return domain;
}
